/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_entropy = /** @type {(inputs: { bits: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.bits} bits`)
};

const es_pw_entropy = /** @type {(inputs: { bits: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.bits} bits`)
};

const de_pw_entropy = /** @type {(inputs: { bits: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.bits} Bits`)
};

const nl_pw_entropy = /** @type {(inputs: { bits: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.bits} bits`)
};

const fr_pw_entropy = /** @type {(inputs: { bits: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.bits} bits`)
};

const it_pw_entropy = /** @type {(inputs: { bits: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.bits} bit`)
};

const pt_br2_pw_entropy = /** @type {(inputs: { bits: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.bits} bits`)
};

const pt_pw_entropy = /** @type {(inputs: { bits: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.bits} bits`)
};

const ja_pw_entropy = /** @type {(inputs: { bits: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.bits} ビット`)
};

const zh_pw_entropy = /** @type {(inputs: { bits: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.bits} 位`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ bits: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_entropy = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_entropy(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_entropy", locale)
	if (locale === "en") return en_pw_entropy(inputs)
	if (locale === "es") return es_pw_entropy(inputs)
	if (locale === "de") return de_pw_entropy(inputs)
	if (locale === "nl") return nl_pw_entropy(inputs)
	if (locale === "fr") return fr_pw_entropy(inputs)
	if (locale === "it") return it_pw_entropy(inputs)
	if (locale === "pt-BR") return pt_br2_pw_entropy(inputs)
	if (locale === "pt") return pt_pw_entropy(inputs)
	if (locale === "ja") return ja_pw_entropy(inputs)
	return zh_pw_entropy(inputs)
};